// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.RapportModal_overlay__jUGTP {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1100;
  opacity: 1;
  animation: RapportModal_fadeIn__gFvW- 0.3s ease-out;
}

.RapportModal_overlay__jUGTP.RapportModal_closing__kTE1N {
  animation: RapportModal_fadeOut__t7GGy 0.3s ease-in forwards;
}

.RapportModal_modal__vP\\+U5 {
  background: #181a1b;
  color: white;
  border-radius: 8px;
  width: 90%;
  max-width: 900px;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.7);
  animation: RapportModal_modalIn__vBHnZ 0.4s ease-out;
}

.RapportModal_modal__vP\\+U5.RapportModal_closing__kTE1N {
  animation: RapportModal_modalOut__bi0Q\\+ 0.3s ease-in forwards;
}

.RapportModal_header__fLNWz {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  border-bottom: 1px solid #444;
  flex-shrink: 0;
}

.RapportModal_header__fLNWz h2 {
  margin: 0;
  font-size: 24px;
  color: #007BFF;
}

.RapportModal_closeButton__kLaOm {
  background: none;
  border: none;
  color: white;
  cursor: pointer;
  font-size: 20px;
  padding: 8px;
  border-radius: 4px;
  transition: background-color 0.2s ease;
}

.RapportModal_closeButton__kLaOm:hover {
  background-color: rgba(255, 255, 255, 0.1);
}

.RapportModal_dateInfo__V1mAe {
  padding: 12px 20px;
  border-bottom: 1px solid #444;
  background: rgba(0, 123, 255, 0.1);
  color: #4a9eff;
  font-size: 14px;
  font-weight: 500;
  flex-shrink: 0;
}

.RapportModal_content__0U6hb {
  padding: 20px;
  overflow-y: auto;
  flex: 1 1;
}

.RapportModal_noData__LKDXg {
  text-align: center;
  padding: 40px;
  color: #bbb;
}

.RapportModal_emailWarning__WEF\\+A {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  background: rgba(255, 152, 0, 0.15);
  border: 1px solid rgba(255, 152, 0, 0.4);
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 20px;
  color: #ffb74d;
}

.RapportModal_emailWarning__WEF\\+A i {
  font-size: 24px;
  flex-shrink: 0;
}

.RapportModal_emailWarning__WEF\\+A strong {
  display: block;
  margin-bottom: 4px;
  color: #ffa726;
}

.RapportModal_emailWarning__WEF\\+A p {
  margin: 0;
  font-size: 14px;
  line-height: 1.4;
}

.RapportModal_rapportList__19tU0 {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.RapportModal_rapportItem__Vv05o {
  display: flex;
  gap: 12px;
  border: 1px solid #444;
  border-radius: 8px;
  padding: 16px;
  background: rgba(255, 255, 255, 0.02);
  transition: all 0.2s ease;
}

.RapportModal_rapportItem__Vv05o:hover {
  background: rgba(255, 255, 255, 0.05);
}

.RapportModal_rapportItem__Vv05o.RapportModal_excluded__wgSWI {
  opacity: 0.5;
  background: rgba(0, 0, 0, 0.2);
  border-color: #333;
}

.RapportModal_checkboxContainer__e-vZT {
  display: flex;
  align-items: flex-start;
  padding-top: 4px;
}

.RapportModal_checkbox__ZOc1a {
  width: 20px;
  height: 20px;
  cursor: pointer;
  accent-color: #4a9eff;
}

.RapportModal_ticketContent__QI6oF {
  flex: 1 1;
  min-width: 0;
}

.RapportModal_tagRow__f8zoB {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
}

.RapportModal_ticketInfo__3UI-p {
  margin-bottom: 12px;
}

.RapportModal_ticketHeader__nR3Lk {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
}

.RapportModal_ticketHeader__nR3Lk h4 {
  margin: 0;
  font-size: 16px;
  color: #fff;
  flex: 1 1;
}

.RapportModal_duration__b\\+uFv {
  font-family: monospace;
  color: #28a745;
  font-weight: bold;
  font-size: 14px;
  background: rgba(40, 167, 69, 0.1);
  padding: 4px 8px;
  border-radius: 4px;
  border: 1px solid rgba(40, 167, 69, 0.3);
}

.RapportModal_bucketTag__5t6Rg {
  display: inline-block;
  background: rgba(138, 43, 226, 0.2);
  color: #a78bfa;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 12px;
  margin-right: 8px;
}

.RapportModal_projectTag__GEYoc {
  display: inline-flex;
  align-items: center;
  background: rgba(0, 123, 255, 0.2);
  color: #4a9eff;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 12px;
}

.RapportModal_projectTag__GEYoc.RapportModal_clickable__VOSy\\+ {
  cursor: pointer;
  transition: all 0.2s ease;
}

.RapportModal_projectTag__GEYoc.RapportModal_clickable__VOSy\\+:hover {
  background: rgba(0, 123, 255, 0.4);
  transform: translateY(-1px);
}

.RapportModal_projectTag__GEYoc.RapportModal_noProject__5\\+5h6 {
  background: rgba(255, 152, 0, 0.2);
  color: #ffb74d;
  border: 1px dashed rgba(255, 152, 0, 0.4);
}

.RapportModal_projectTag__GEYoc.RapportModal_noProject__5\\+5h6:hover {
  background: rgba(255, 152, 0, 0.3);
}

.RapportModal_taskName__QIrOy {
  opacity: 0.8;
  font-style: italic;
}

.RapportModal_inputContainer__OWtAp {
  margin-top: 12px;
}

.RapportModal_inputContainer__OWtAp label {
  display: block;
  margin-bottom: 8px;
  font-size: 13px;
  color: #bbb;
  font-weight: 500;
}

.RapportModal_rapportInput__61Qxa {
  width: 100%;
  background: #23272a;
  border: 1px solid #444;
  border-radius: 4px;
  color: white;
  padding: 10px;
  font-size: 14px;
  font-family: inherit;
  resize: vertical;
  min-height: 60px;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.RapportModal_rapportInput__61Qxa:focus {
  outline: none;
  border-color: #007BFF;
  box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.1);
}

.RapportModal_rapportInput__61Qxa::placeholder {
  color: #666;
  font-style: italic;
}

.RapportModal_footer__-JUbY {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding: 20px;
  border-top: 1px solid #444;
  flex-shrink: 0;
}

.RapportModal_cancelButton__zqgB0 {
  background: rgba(108, 117, 125, 0.8);
  border: none;
  border-radius: 4px;
  color: white;
  padding: 10px 20px;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.RapportModal_cancelButton__zqgB0:hover {
  background: rgba(108, 117, 125, 1);
  transform: translateY(-1px);
}

.RapportModal_submitButton__Q7lAM {
  background: rgba(0, 123, 255, 0.8);
  border: none;
  border-radius: 4px;
  color: white;
  padding: 10px 20px;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.RapportModal_submitButton__Q7lAM:hover:not(:disabled) {
  background: rgba(0, 123, 255, 1);
  transform: translateY(-1px);
}

.RapportModal_submitButton__Q7lAM:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* Animations */
@keyframes RapportModal_fadeIn__gFvW- {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes RapportModal_fadeOut__t7GGy {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}

@keyframes RapportModal_modalIn__vBHnZ {
  0% {
    opacity: 0;
    transform: scale(0.8) translateY(30px);
  }
  60% {
    opacity: 0.8;
    transform: scale(1.02) translateY(-5px);
  }
  100% {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}

@keyframes RapportModal_modalOut__bi0Q\\+ {
  0% {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
  100% {
    opacity: 0;
    transform: scale(0.8) translateY(30px);
  }
}

/* Status states for rapport items */
.RapportModal_rapportItem__Vv05o.RapportModal_submitted__UwLje {
  border-color: #28a745;
  background: rgba(40, 167, 69, 0.1);
}

.RapportModal_rapportItem__Vv05o.RapportModal_failed__4h7ru {
  border-color: #dc3545;
  background: rgba(220, 53, 69, 0.1);
}

.RapportModal_rapportItem__Vv05o.RapportModal_skipped__Pft95 {
  border-color: #ff9800;
  background: rgba(255, 152, 0, 0.1);
}

/* Notification styles */
.RapportModal_notification__eVPKF {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  margin: 0;
  border-bottom: 1px solid #444;
  animation: RapportModal_slideIn__-dq1G 0.3s ease-out;
}

.RapportModal_notification__eVPKF.RapportModal_success__erksI {
  background: rgba(40, 167, 69, 0.15);
  color: #75d99a;
}

.RapportModal_notification__eVPKF.RapportModal_warning__YpMu0 {
  background: rgba(255, 152, 0, 0.15);
  color: #ffb74d;
}

.RapportModal_notification__eVPKF.RapportModal_error__rjB15 {
  background: rgba(220, 53, 69, 0.15);
  color: #f28b9a;
}

.RapportModal_notificationIcon__HBhBy {
  font-size: 18px;
  font-weight: bold;
  flex-shrink: 0;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
}

.RapportModal_notification__eVPKF.RapportModal_success__erksI .RapportModal_notificationIcon__HBhBy {
  background: rgba(40, 167, 69, 0.3);
}

.RapportModal_notification__eVPKF.RapportModal_warning__YpMu0 .RapportModal_notificationIcon__HBhBy {
  background: rgba(255, 152, 0, 0.3);
}

.RapportModal_notification__eVPKF.RapportModal_error__rjB15 .RapportModal_notificationIcon__HBhBy {
  background: rgba(220, 53, 69, 0.3);
}

.RapportModal_notificationMessage__UtRBV {
  flex: 1 1;
  font-size: 14px;
}

.RapportModal_notificationClose__gYP3F {
  background: none;
  border: none;
  color: inherit;
  cursor: pointer;
  padding: 4px 8px;
  border-radius: 4px;
  opacity: 0.7;
  transition: opacity 0.2s ease, background-color 0.2s ease;
}

.RapportModal_notificationClose__gYP3F:hover {
  opacity: 1;
  background: rgba(255, 255, 255, 0.1);
}

@keyframes RapportModal_slideIn__-dq1G {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Mobile optimizations */
@media (max-width: 768px) {
  .RapportModal_modal__vP\\+U5 {
    width: 95%;
    max-height: 95vh;
  }

  .RapportModal_ticketHeader__nR3Lk {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }

  .RapportModal_footer__-JUbY {
    flex-direction: column;
  }

  .RapportModal_cancelButton__zqgB0,
  .RapportModal_submitButton__Q7lAM {
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/RapportModal.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,UAAU;EACV,mDAA+B;AACjC;;AAEA;EACE,4DAAwC;AAC1C;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,yCAAyC;EACzC,oDAAgC;AAClC;;AAEA;EACE,8DAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,6BAA6B;EAC7B,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,kCAAkC;EAClC,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,SAAO;AACT;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;AACb;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,mCAAmC;EACnC,wCAAwC;EACxC,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;EACT,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,qCAAqC;EACrC,yBAAyB;AAC3B;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,YAAY;EACZ,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,WAAW;EACX,SAAO;AACT;;AAEA;EACE,sBAAsB;EACtB,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,kCAAkC;EAClC,gBAAgB;EAChB,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,qBAAqB;EACrB,mCAAmC;EACnC,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,kCAAkC;EAClC,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,kCAAkC;EAClC,2BAA2B;AAC7B;;AAEA;EACE,kCAAkC;EAClC,cAAc;EACd,yCAAyC;AAC3C;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;EAChB,wDAAwD;AAC1D;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,aAAa;EACb,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,kCAAkC;EAClC,2BAA2B;AAC7B;;AAEA;EACE,kCAAkC;EAClC,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;EAChC,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,eAAe;AACf;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;IACV,sCAAsC;EACxC;EACA;IACE,YAAY;IACZ,uCAAuC;EACzC;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA;EACE;IACE,UAAU;IACV,iCAAiC;EACnC;EACA;IACE,UAAU;IACV,sCAAsC;EACxC;AACF;;AAEA,oCAAoC;AACpC;EACE,qBAAqB;EACrB,kCAAkC;AACpC;;AAEA;EACE,qBAAqB;EACrB,kCAAkC;AACpC;;AAEA;EACE,qBAAqB;EACrB,kCAAkC;AACpC;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,SAAS;EACT,6BAA6B;EAC7B,oDAAgC;AAClC;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,SAAO;EACP,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,yDAAyD;AAC3D;;AAEA;EACE,UAAU;EACV,oCAAoC;AACtC;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,yBAAyB;AACzB;EACE;IACE,UAAU;IACV,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,QAAQ;EACV;;EAEA;IACE,sBAAsB;EACxB;;EAEA;;IAEE,WAAW;EACb;AACF","sourcesContent":[".overlay {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  background: rgba(0, 0, 0, 0.7);\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  z-index: 1100;\r\n  opacity: 1;\r\n  animation: fadeIn 0.3s ease-out;\r\n}\r\n\r\n.overlay.closing {\r\n  animation: fadeOut 0.3s ease-in forwards;\r\n}\r\n\r\n.modal {\r\n  background: #181a1b;\r\n  color: white;\r\n  border-radius: 8px;\r\n  width: 90%;\r\n  max-width: 900px;\r\n  max-height: 90vh;\r\n  display: flex;\r\n  flex-direction: column;\r\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.7);\r\n  animation: modalIn 0.4s ease-out;\r\n}\r\n\r\n.modal.closing {\r\n  animation: modalOut 0.3s ease-in forwards;\r\n}\r\n\r\n.header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  padding: 20px;\r\n  border-bottom: 1px solid #444;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.header h2 {\r\n  margin: 0;\r\n  font-size: 24px;\r\n  color: #007BFF;\r\n}\r\n\r\n.closeButton {\r\n  background: none;\r\n  border: none;\r\n  color: white;\r\n  cursor: pointer;\r\n  font-size: 20px;\r\n  padding: 8px;\r\n  border-radius: 4px;\r\n  transition: background-color 0.2s ease;\r\n}\r\n\r\n.closeButton:hover {\r\n  background-color: rgba(255, 255, 255, 0.1);\r\n}\r\n\r\n.dateInfo {\r\n  padding: 12px 20px;\r\n  border-bottom: 1px solid #444;\r\n  background: rgba(0, 123, 255, 0.1);\r\n  color: #4a9eff;\r\n  font-size: 14px;\r\n  font-weight: 500;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.content {\r\n  padding: 20px;\r\n  overflow-y: auto;\r\n  flex: 1;\r\n}\r\n\r\n.noData {\r\n  text-align: center;\r\n  padding: 40px;\r\n  color: #bbb;\r\n}\r\n\r\n.emailWarning {\r\n  display: flex;\r\n  align-items: flex-start;\r\n  gap: 12px;\r\n  background: rgba(255, 152, 0, 0.15);\r\n  border: 1px solid rgba(255, 152, 0, 0.4);\r\n  border-radius: 8px;\r\n  padding: 16px;\r\n  margin-bottom: 20px;\r\n  color: #ffb74d;\r\n}\r\n\r\n.emailWarning i {\r\n  font-size: 24px;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.emailWarning strong {\r\n  display: block;\r\n  margin-bottom: 4px;\r\n  color: #ffa726;\r\n}\r\n\r\n.emailWarning p {\r\n  margin: 0;\r\n  font-size: 14px;\r\n  line-height: 1.4;\r\n}\r\n\r\n.rapportList {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 16px;\r\n}\r\n\r\n.rapportItem {\r\n  display: flex;\r\n  gap: 12px;\r\n  border: 1px solid #444;\r\n  border-radius: 8px;\r\n  padding: 16px;\r\n  background: rgba(255, 255, 255, 0.02);\r\n  transition: all 0.2s ease;\r\n}\r\n\r\n.rapportItem:hover {\r\n  background: rgba(255, 255, 255, 0.05);\r\n}\r\n\r\n.rapportItem.excluded {\r\n  opacity: 0.5;\r\n  background: rgba(0, 0, 0, 0.2);\r\n  border-color: #333;\r\n}\r\n\r\n.checkboxContainer {\r\n  display: flex;\r\n  align-items: flex-start;\r\n  padding-top: 4px;\r\n}\r\n\r\n.checkbox {\r\n  width: 20px;\r\n  height: 20px;\r\n  cursor: pointer;\r\n  accent-color: #4a9eff;\r\n}\r\n\r\n.ticketContent {\r\n  flex: 1;\r\n  min-width: 0;\r\n}\r\n\r\n.tagRow {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: 8px;\r\n  align-items: center;\r\n}\r\n\r\n.ticketInfo {\r\n  margin-bottom: 12px;\r\n}\r\n\r\n.ticketHeader {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  margin-bottom: 8px;\r\n}\r\n\r\n.ticketHeader h4 {\r\n  margin: 0;\r\n  font-size: 16px;\r\n  color: #fff;\r\n  flex: 1;\r\n}\r\n\r\n.duration {\r\n  font-family: monospace;\r\n  color: #28a745;\r\n  font-weight: bold;\r\n  font-size: 14px;\r\n  background: rgba(40, 167, 69, 0.1);\r\n  padding: 4px 8px;\r\n  border-radius: 4px;\r\n  border: 1px solid rgba(40, 167, 69, 0.3);\r\n}\r\n\r\n.bucketTag {\r\n  display: inline-block;\r\n  background: rgba(138, 43, 226, 0.2);\r\n  color: #a78bfa;\r\n  padding: 2px 8px;\r\n  border-radius: 4px;\r\n  font-size: 12px;\r\n  margin-right: 8px;\r\n}\r\n\r\n.projectTag {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  background: rgba(0, 123, 255, 0.2);\r\n  color: #4a9eff;\r\n  padding: 2px 8px;\r\n  border-radius: 4px;\r\n  font-size: 12px;\r\n}\r\n\r\n.projectTag.clickable {\r\n  cursor: pointer;\r\n  transition: all 0.2s ease;\r\n}\r\n\r\n.projectTag.clickable:hover {\r\n  background: rgba(0, 123, 255, 0.4);\r\n  transform: translateY(-1px);\r\n}\r\n\r\n.projectTag.noProject {\r\n  background: rgba(255, 152, 0, 0.2);\r\n  color: #ffb74d;\r\n  border: 1px dashed rgba(255, 152, 0, 0.4);\r\n}\r\n\r\n.projectTag.noProject:hover {\r\n  background: rgba(255, 152, 0, 0.3);\r\n}\r\n\r\n.taskName {\r\n  opacity: 0.8;\r\n  font-style: italic;\r\n}\r\n\r\n.inputContainer {\r\n  margin-top: 12px;\r\n}\r\n\r\n.inputContainer label {\r\n  display: block;\r\n  margin-bottom: 8px;\r\n  font-size: 13px;\r\n  color: #bbb;\r\n  font-weight: 500;\r\n}\r\n\r\n.rapportInput {\r\n  width: 100%;\r\n  background: #23272a;\r\n  border: 1px solid #444;\r\n  border-radius: 4px;\r\n  color: white;\r\n  padding: 10px;\r\n  font-size: 14px;\r\n  font-family: inherit;\r\n  resize: vertical;\r\n  min-height: 60px;\r\n  transition: border-color 0.2s ease, box-shadow 0.2s ease;\r\n}\r\n\r\n.rapportInput:focus {\r\n  outline: none;\r\n  border-color: #007BFF;\r\n  box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.1);\r\n}\r\n\r\n.rapportInput::placeholder {\r\n  color: #666;\r\n  font-style: italic;\r\n}\r\n\r\n.footer {\r\n  display: flex;\r\n  justify-content: flex-end;\r\n  gap: 12px;\r\n  padding: 20px;\r\n  border-top: 1px solid #444;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.cancelButton {\r\n  background: rgba(108, 117, 125, 0.8);\r\n  border: none;\r\n  border-radius: 4px;\r\n  color: white;\r\n  padding: 10px 20px;\r\n  font-size: 14px;\r\n  cursor: pointer;\r\n  transition: all 0.2s ease;\r\n}\r\n\r\n.cancelButton:hover {\r\n  background: rgba(108, 117, 125, 1);\r\n  transform: translateY(-1px);\r\n}\r\n\r\n.submitButton {\r\n  background: rgba(0, 123, 255, 0.8);\r\n  border: none;\r\n  border-radius: 4px;\r\n  color: white;\r\n  padding: 10px 20px;\r\n  font-size: 14px;\r\n  cursor: pointer;\r\n  transition: all 0.2s ease;\r\n}\r\n\r\n.submitButton:hover:not(:disabled) {\r\n  background: rgba(0, 123, 255, 1);\r\n  transform: translateY(-1px);\r\n}\r\n\r\n.submitButton:disabled {\r\n  opacity: 0.5;\r\n  cursor: not-allowed;\r\n}\r\n\r\n/* Animations */\r\n@keyframes fadeIn {\r\n  from {\r\n    opacity: 0;\r\n  }\r\n  to {\r\n    opacity: 1;\r\n  }\r\n}\r\n\r\n@keyframes fadeOut {\r\n  from {\r\n    opacity: 1;\r\n  }\r\n  to {\r\n    opacity: 0;\r\n  }\r\n}\r\n\r\n@keyframes modalIn {\r\n  0% {\r\n    opacity: 0;\r\n    transform: scale(0.8) translateY(30px);\r\n  }\r\n  60% {\r\n    opacity: 0.8;\r\n    transform: scale(1.02) translateY(-5px);\r\n  }\r\n  100% {\r\n    opacity: 1;\r\n    transform: scale(1) translateY(0);\r\n  }\r\n}\r\n\r\n@keyframes modalOut {\r\n  0% {\r\n    opacity: 1;\r\n    transform: scale(1) translateY(0);\r\n  }\r\n  100% {\r\n    opacity: 0;\r\n    transform: scale(0.8) translateY(30px);\r\n  }\r\n}\r\n\r\n/* Status states for rapport items */\r\n.rapportItem.submitted {\r\n  border-color: #28a745;\r\n  background: rgba(40, 167, 69, 0.1);\r\n}\r\n\r\n.rapportItem.failed {\r\n  border-color: #dc3545;\r\n  background: rgba(220, 53, 69, 0.1);\r\n}\r\n\r\n.rapportItem.skipped {\r\n  border-color: #ff9800;\r\n  background: rgba(255, 152, 0, 0.1);\r\n}\r\n\r\n/* Notification styles */\r\n.notification {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 12px;\r\n  padding: 12px 16px;\r\n  margin: 0;\r\n  border-bottom: 1px solid #444;\r\n  animation: slideIn 0.3s ease-out;\r\n}\r\n\r\n.notification.success {\r\n  background: rgba(40, 167, 69, 0.15);\r\n  color: #75d99a;\r\n}\r\n\r\n.notification.warning {\r\n  background: rgba(255, 152, 0, 0.15);\r\n  color: #ffb74d;\r\n}\r\n\r\n.notification.error {\r\n  background: rgba(220, 53, 69, 0.15);\r\n  color: #f28b9a;\r\n}\r\n\r\n.notificationIcon {\r\n  font-size: 18px;\r\n  font-weight: bold;\r\n  flex-shrink: 0;\r\n  width: 24px;\r\n  height: 24px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  border-radius: 50%;\r\n}\r\n\r\n.notification.success .notificationIcon {\r\n  background: rgba(40, 167, 69, 0.3);\r\n}\r\n\r\n.notification.warning .notificationIcon {\r\n  background: rgba(255, 152, 0, 0.3);\r\n}\r\n\r\n.notification.error .notificationIcon {\r\n  background: rgba(220, 53, 69, 0.3);\r\n}\r\n\r\n.notificationMessage {\r\n  flex: 1;\r\n  font-size: 14px;\r\n}\r\n\r\n.notificationClose {\r\n  background: none;\r\n  border: none;\r\n  color: inherit;\r\n  cursor: pointer;\r\n  padding: 4px 8px;\r\n  border-radius: 4px;\r\n  opacity: 0.7;\r\n  transition: opacity 0.2s ease, background-color 0.2s ease;\r\n}\r\n\r\n.notificationClose:hover {\r\n  opacity: 1;\r\n  background: rgba(255, 255, 255, 0.1);\r\n}\r\n\r\n@keyframes slideIn {\r\n  from {\r\n    opacity: 0;\r\n    transform: translateY(-10px);\r\n  }\r\n  to {\r\n    opacity: 1;\r\n    transform: translateY(0);\r\n  }\r\n}\r\n\r\n/* Mobile optimizations */\r\n@media (max-width: 768px) {\r\n  .modal {\r\n    width: 95%;\r\n    max-height: 95vh;\r\n  }\r\n\r\n  .ticketHeader {\r\n    flex-direction: column;\r\n    align-items: flex-start;\r\n    gap: 8px;\r\n  }\r\n\r\n  .footer {\r\n    flex-direction: column;\r\n  }\r\n\r\n  .cancelButton,\r\n  .submitButton {\r\n    width: 100%;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"overlay": `RapportModal_overlay__jUGTP`,
	"fadeIn": `RapportModal_fadeIn__gFvW-`,
	"closing": `RapportModal_closing__kTE1N`,
	"fadeOut": `RapportModal_fadeOut__t7GGy`,
	"modal": `RapportModal_modal__vP+U5`,
	"modalIn": `RapportModal_modalIn__vBHnZ`,
	"modalOut": `RapportModal_modalOut__bi0Q+`,
	"header": `RapportModal_header__fLNWz`,
	"closeButton": `RapportModal_closeButton__kLaOm`,
	"dateInfo": `RapportModal_dateInfo__V1mAe`,
	"content": `RapportModal_content__0U6hb`,
	"noData": `RapportModal_noData__LKDXg`,
	"emailWarning": `RapportModal_emailWarning__WEF+A`,
	"rapportList": `RapportModal_rapportList__19tU0`,
	"rapportItem": `RapportModal_rapportItem__Vv05o`,
	"excluded": `RapportModal_excluded__wgSWI`,
	"checkboxContainer": `RapportModal_checkboxContainer__e-vZT`,
	"checkbox": `RapportModal_checkbox__ZOc1a`,
	"ticketContent": `RapportModal_ticketContent__QI6oF`,
	"tagRow": `RapportModal_tagRow__f8zoB`,
	"ticketInfo": `RapportModal_ticketInfo__3UI-p`,
	"ticketHeader": `RapportModal_ticketHeader__nR3Lk`,
	"duration": `RapportModal_duration__b+uFv`,
	"bucketTag": `RapportModal_bucketTag__5t6Rg`,
	"projectTag": `RapportModal_projectTag__GEYoc`,
	"clickable": `RapportModal_clickable__VOSy+`,
	"noProject": `RapportModal_noProject__5+5h6`,
	"taskName": `RapportModal_taskName__QIrOy`,
	"inputContainer": `RapportModal_inputContainer__OWtAp`,
	"rapportInput": `RapportModal_rapportInput__61Qxa`,
	"footer": `RapportModal_footer__-JUbY`,
	"cancelButton": `RapportModal_cancelButton__zqgB0`,
	"submitButton": `RapportModal_submitButton__Q7lAM`,
	"submitted": `RapportModal_submitted__UwLje`,
	"failed": `RapportModal_failed__4h7ru`,
	"skipped": `RapportModal_skipped__Pft95`,
	"notification": `RapportModal_notification__eVPKF`,
	"slideIn": `RapportModal_slideIn__-dq1G`,
	"success": `RapportModal_success__erksI`,
	"warning": `RapportModal_warning__YpMu0`,
	"error": `RapportModal_error__rjB15`,
	"notificationIcon": `RapportModal_notificationIcon__HBhBy`,
	"notificationMessage": `RapportModal_notificationMessage__UtRBV`,
	"notificationClose": `RapportModal_notificationClose__gYP3F`
};
export default ___CSS_LOADER_EXPORT___;
